export const blockIconsAndroidStorageNew = (
	<span className='material-symbols-outlined'>storage</span>
);
